<template>
    <v-flex xs12 v-if="showAboutTile">
        <v-card class="panelBlock">
            <v-expansion-panel class="about-section">
                <v-expansion-panel-content>
                    <div slot="header">
                        <h2 data-qe-id="about_tile_header">{{communityCommonConstant.about.TITLE}}</h2>
                    </div>
                    <v-flex xs12 v-if="canViewChair">
                        <chair-message></chair-message>
                    </v-flex>
                    <v-flex xs12 v-if="canViewAbout">
                        <about></about>
                    </v-flex>
                    <v-flex v-if="canViewSponsors">
                        <sponsors></sponsors>
                    </v-flex>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-card>
    </v-flex>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { storeAction } from '../../../store/storeActions.constant';
    import { storeMutation } from "../../../store/storeMutations.constant";
    import Sponsors from '../SponsorCard/Sponsors';
    import ChairMessage from '../ChairMessage/ChairMessage.vue';
    import About from "../About/About";
    import { routerNames } from "../../appCommon.constants";
    import { communityCommonConstant } from '../communityCommon.constant';
import { myToolsConstants } from '../../Tools/mytools.constant';

    export default {
        name: 'AboutTile',
        components: {
            Sponsors,
            ChairMessage,
            About,
        },
        props: {
            canViewAbout: {
                type: Boolean,
                required: true,
            },
            canViewChair: {
                type: Boolean,
                required: true,
            },
            canViewSponsors: {
                type: Boolean,
                required: true,
            },
        },
        created() {
            if (this.canViewAbout) {
                this.getAboutView();
            }
            if (this.canViewChair) {
                this.getChairMessage();
            } else {
                this.setSponsorList([]);
            }
            if (this.canViewSponsors) {
                this.getSponsorLists(this.$route.params.communityId);
            } else {
                this.setChairMessage("");
            }
        },
        data: () => {
            return {
                communityCommonConstant,
                routerNames,
            };
        },
        computed: {
            ...mapGetters({
                canEditSponsor: `sponsor/${storeGetters.canEditSponsor}`,
                aboutView: `chapter/${storeGetters.aboutView}`,
                chairMessage: `chapter/${storeGetters.chairMessage}`,
                sponsorLists: `sponsor/${storeGetters.sponsorLists}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            }),
            showAboutTile() {
                return (this.aboutView && this.aboutView.isAboutMessageVisible && !!this.aboutView.message) ||
                    (this.chairMessage && this.chairMessage.isChairMessageVisible && !!this.chairMessage.message) ||
                    (this.sponsorLists && this.sponsorLists.length > 0) ||
                    ((this.aboutView && this.aboutView.canEdit) || (this.canEditSponsor) || (this.chairMessage && this.chairMessage.canEdit));
            },
            showSponsors() {
                return (this.$route.path.includes('/chapter') || this.$route.path.includes('/network')) && this.isVisible && (this.sponsorLists.length > 0 || this.canEditSponsor);
            },
            isVisible() {
                return this.usersCommunitiesList && !this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE) && !this.$route.path.includes('/businesses');
            },
        },
        methods: {
            ...mapActions({
                getAboutView: `chapter/${storeAction.getAboutView}`,
                getSponsorLists: `sponsor/${storeAction.getSponsorsList}`,
                getChairMessage: `chapter/${storeAction.getChairMessage}`,
            }),
            ...mapMutations({
                setSponsorList: `sponsor/${storeMutation.setSponsorList}`,
                setChairMessage: `chapter/${storeMutation.setChairMessage}`,
            }),
        },
    };
</script>

<style lang="scss">
    .about-section,
    .txhub-section {
        box-shadow: none !important;

        .v-expansion-panel__container {
            border: none;
            border-radius: 4px;
        }

        .v-expansion-panel__header {
            padding: 0px;

            h2 {
                border: none;
            }

            &__icon {
                padding-right: 10px;
            }
        }
    }
</style>
